export default "__VITE_ASSET__9fef28b3__"